/*
 * slimscroll
 * http://github.com/yawetse/slimscroll
 *
 * Copyright (c) 2014 Yaw Joseph Etse. All rights reserved.
 */
module.exports = require('./lib/slimscroll');